import Vue from 'vue';
import store from '@/store';
import router from '@/router';

export function useAuthentication() {
  const isAuthenticated = () => store.getters['auth/isAuthenticated'];
  const isAdmin = () => store.getters['auth/isAdmin'];
  const authToken = () => store.getters['auth/getToken'];

  const isAuthenticatedUser = () => isAuthenticated() && !isAdmin();

  const isAuthenticatedAdmin = () => isAuthenticated() && isAdmin();

  const handleAuthError = async (error) => {
    if (error.response?.status === 401) {
      await store.dispatch('auth/LOGOUT');
      await router.push('/login');
      throw new Error('authentication.session_expired');
    }
    throw error;
  };

  // Create a Vue instance for reactivity
  const authState = new Vue({
    computed: {
      isAuthenticated() {
        return store.getters['auth/isAuthenticated'];
      },
      isAdmin() {
        return store.getters['auth/isAdmin'];
      },
      isAuthenticatedUser() {
        return this.isAuthenticated && !this.isAdmin;
      },
      isAuthenticatedAdmin() {
        return this.isAuthenticated && this.isAdmin;
      },
    },
  });

  return {
    isAuthenticated: () => authState.isAuthenticated,
    isAdmin: () => authState.isAdmin,
    authToken: () => authToken(),
    isAuthenticatedUser: () => authState.isAuthenticatedUser,
    isAuthenticatedAdmin: () => authState.isAuthenticatedAdmin,
    handleAuthError,
  };
}
